import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[appIndeterminate]'
})
export class IndeterminateDirective implements OnChanges {
  @Input() appIndeterminate = false;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnChanges(): void {
    this.el.nativeElement.indeterminate = this.appIndeterminate;
  }
}
